import { FormControl, Input, InputLabel } from "@mui/material";
import { useFormContext } from "react-hook-form";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const Index = () => {
  const { register } = useFormContext();
  return (
    <FormControl
      fullWidth
      sx={{ mt: 3 }}
      error={!daLiJePoljeValidno("emailAdresa")}
    >
      <InputLabel htmlFor={"nazivPolja"}>E-mail</InputLabel>
      <Input {...register("emailAdresa")} />
      <PorukaGreskePolja nazivPolja={"emailAdresa"} />
    </FormControl>
  );
};

export default Index;
